import parse from 'html-react-parser';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import Catch from './functional-error-boundary';
import Config from 'Config';

const ErrorBoundary = Catch(function MyErrorBoundary(props: any, error?: Error) {
	const [content, setContent] = useState<any>();
	useEffect(() => {
		try {
			if (props.content) {
				let c = sanitizeHtml(props.content) as any;
				c = parse(c);
				setContent(c as any);
			}
		} catch (err) {
			setContent('error');
		}
	}, [props.content]);

	if (error) {
		return (
			<>
				<span className="html-content">{content}</span>;
			</>
		);
	} else {
		return <React.Fragment>{props.children}</React.Fragment>;
	}
});

interface IHtmlContent {
	content?: string;
}

// Add token to image URLs for authentication
const addTokenToImageUrls = (html: string): string => {
	if (!html) return html;

	const token = localStorage.getItem('token');
	if (!token) return html;

	// Find all image URLs for documents and add token if not present
	const regex = new RegExp(`(${Config.API_BASE_URL}/api/documents/[^/]+/images/[^"?\\s]+)(?![^<]*\\?token)`, 'g');
	return html.replace(regex, `$1?token=${encodeURIComponent(token)}`);
};

export const HtmlContent = observer((props: IHtmlContent) => {
	const [content, setContent] = useState<any>();

	useEffect(() => {
		try {
			if (props.content) {
				// Add token to image URLs before parsing
				const contentWithTokens = addTokenToImageUrls(props.content);
				let c = parse(contentWithTokens);
				setContent(c as any);
			}
		} catch (err) {
			try {
				if (props.content) {
					const contentWithTokens = addTokenToImageUrls(props.content);
					let c = sanitizeHtml(contentWithTokens) as any;
					c = parse(c);
					setContent(c as any);
				}
			} catch (err) {
				setContent('Fehler: Inhalt konnte nicht dargestellt werden');
			}
		}
	}, [props.content]);

	if (props.content) {
		return (
			<ErrorBoundary content={props.content}>
				<span className="html-content">{content}</span>
			</ErrorBoundary>
		);
	}

	return (
		<div className="html-content is-empty">
			<span>Kein Inhalt</span>
		</div>
	);
});
